


<button *ngIf="popup" class="btn btn-default btn-sm" [nbPopover]="contact" >{{value?.title}}</button>

<div *ngIf="!popup">
  <div class="contact">
    <!-- <div class="row">
      <div class="col-6"><label>Title</label></div>
      <div class="col-6">{{value?.title}}</div>
    </div>
    <div class="row" *ngFor="let item of value?.fields">
      <div class="col-6"><label>{{fieldTypes[item.type]}}</label></div>
      <div class="col-6">{{item.value}}</div>
    </div> -->
    <table>
      <tr><td><label>Title</label></td><td>{{value?.title}}</td></tr>
      <tr *ngFor="let item of value?.fields"><td><label>{{fieldTypes[item.type]}}</label></td><td>{{item.value}}</td></tr>
    </table>
  </div>  
</div>

<ng-template #contact >
  <div class="contact">
    <!-- <div class="row">
      <div class="col-6"><label>Title</label></div>
      <div class="col-6">{{value?.title}}</div>
    </div>
    <div class="row" *ngFor="let item of value?.fields">
      <div class="col-6"><label>{{fieldTypes[item.type]}}</label></div>
      <div class="col-6">{{item.value}}</div>
    </div> -->
    <table>
      <tr><td>Title</td><td>{{value?.title}}</td></tr>
      <tr *ngFor="let item of value?.fields"><td>{{fieldTypes[item.type]}}</td><td>{{item.value}}</td></tr>
    </table>
  </div>
</ng-template>
